import { createSelector } from 'reselect';

/**
 * Get loader state.
 *
 * @author Mikhail Siutsou
 * @function getLoaderState
 * @category Selectors
 * @subcategory Loader
 * @param {AppState} state state.
 * @return {LoaderState} loader state.
 */
var getLoaderState = function getLoaderState(state) {
  return state.loader;
};

export var getLoaderSelector = createSelector(getLoaderState, function (loader) {
  return loader;
});